import firebase from 'firebase'

type Props = {
    playbookId: string
    orgId: string
    uid: string
    fileName: string
    base64Data: string
}
/**
 *
 * @param {string} playbookId
 * @param {string} orgId
 * @param {string} uid
 * @param {string} fileName should contain file extension
 * @param {string} base64Data base64 encoded string
 * @returns {string} url of the uploaded image
 */
export const uploadThumbnail = async ({ playbookId, orgId, uid, fileName, base64Data }: Props) => {
    // create storage ref
    const storageRef = firebase
        .storage()
        .ref(`/chaptersScreenshot/${orgId}/${uid}/${playbookId}/${fileName}`)

    // convert base64 to File object
    const res = await fetch(base64Data)
    const blob = await res.blob()
    const file = new File([blob], fileName, { type: 'image/png' })

    // upload it to storage
    await storageRef.put(file, {
        contentType: 'image/png',
        cacheControl: 'public,max-age=3600'
    })

    // return url link from storage
    return storageRef.getDownloadURL()
}
